import { formatDateFullFormat, formatDatePartialFormat } from '@widergy/web-utils/lib/date';

import numeral from 'config/numeral';

export const billForView = bill =>
  bill && {
    ...bill,
    issued_on: formatDateFullFormat(bill.issued_on),
    first_expiration_on: formatDateFullFormat(bill.first_expiration_on),
    second_expiration_on: formatDateFullFormat(bill.second_expiration_on),
    period: formatDatePartialFormat(bill.period),
    second_expiration_amount: numeral(bill.surcharge_amount).format('$0,0.[00]'),
    consumption: `${numeral(bill.consumption).format()} kWh`,
    download: {
      id: bill.id,
      period: formatDatePartialFormat(bill.period),
      amount: numeral(bill.amount).format('$0,0.[00]'),
      url: bill.printedBill,
      downloadable: bill.downloadable,
      external_id: bill.external_id
    }
  };
